import { ArrowBackRounded, HomeRounded } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { Link as RRLink, useHistory } from 'react-router-dom';
import Pic403 from './../../assets/Error403.png';

export default function Error403() {
  const history = useHistory();

  return (
    <Box sx={{ display: 'block', textAlign: 'center', mb: 10 }}>
      <Box sx={{ width: { xs: 280, sm: 480 }, mx: 'auto' }}>
        <img
          style={{ marginTop: 80, width: '100%' }}
          src={Pic403}
          alt="Error403"
        />
      </Box>
      <Box>
        <Typography
          sx={(theme) => ({
            textDecoration: 'none',
            color: theme.palette.text.secondary,
            fontSize: 8
          })}
          component="a"
          href="https://www.freepik.com/vectors"
        >
          Vector created by stories - www.freepik.com
        </Typography>
      </Box>
      <Typography
        sx={{ px: 4, mt: 1.5, mb: 1.75, fontWeight: 'bold' }}
        component="h3"
      >
        Unfortunately, you do not have permission to view this page.
      </Typography>
      <Button
        sx={{ m: 1, mt: 0 }}
        color="primary"
        size="large"
        startIcon={<ArrowBackRounded />}
        onClick={() => {
          history.goBack();
        }}
      >
        Back
      </Button>
      <Button
        sx={{ m: 1, mt: 0 }}
        component={RRLink}
        to="/"
        variant="contained"
        color="primary"
        size="large"
        startIcon={<HomeRounded />}
      >
        Home
      </Button>
    </Box>
  );
}
